import React, {useState, useEffect} from 'react';
import { Tabs,Tab } from "react-bootstrap";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { toast, ToastContainer } from "react-toastify";
import { LiquidityTab } from './LiquidityTab';
import { CashFlowTab } from './CashFlowTab';
import { ContactExpensesTab } from './ContactExpensesTab';
        
export const Liquidity = () => {
    
    const Level = [{ BreadCrumb: "Portfolio >", Routes: `${UrlPath.PortfolioList}` }, {BreadCrumb:"Liquidity & Cash Forecasting", Routes:`/${UrlPath.PortfolioLiquidity}`}];
    const [activeTab,setActiveTab]=useState("Liquidity");
 
    useEffect(()=>{
        document.title="Liquidity";
    },[]);
 
    
    return <>
        <TopBar label={"Liquidity & Cash Forecasting"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level}/>
            <div className="container-fluid p-4">
            <Tabs activeKey={activeTab} onSelect={(key)=>{setActiveTab(key)}}>
                <Tab className="life-science rounded  border-top-0 "  eventKey="Liquidity" title="Liquidity" >
                 {activeTab==="Liquidity" &&<LiquidityTab/>}
                </Tab>
                <Tab  className="life-science rounded  border-top-0" eventKey="CashFlow" title="Modeling">
                {activeTab==="CashFlow" && <CashFlowTab/>}
                </Tab>
                <Tab  className="life-science rounded  border-top-0" eventKey="expenses" title="Income & Expenses">
                {activeTab==="expenses" && <ContactExpensesTab/>}
                </Tab>
            </Tabs>
            </div>
        </div>
        <ToastContainer/>
 
        
    </>
    
}
